import { createEvent, createEffect, sample } from "effector";
import { RouterModule } from "@features/shared/router";
import { FEATURES } from "@features/features-list";
import { OnboardingModule } from "@features/onboarding/model";
import { SubscriptionModule } from "@features/subscription/model";
import { getTruegateHostUrl } from "../../../utils/getTruegateHostUrl";

// Events
export const renewSubscriptionRequested = createEvent();
export const subscribeAgainRequested = createEvent();

// Effects
export const navigateToPaywallFx = createEffect(() => {
    const routerContract = FEATURES.getByType<RouterModule>(RouterModule).getContract();
    const routerPush = routerContract.events.routerPush;
    const subscriptionContract = FEATURES.getByType<SubscriptionModule>(SubscriptionModule).getContract();
    const paymentSystem = subscriptionContract.stores.$paymentSystem.getState();
    const path = "/profile/settings/subscriptions/renew";
    const target = paymentSystem === "truegate" ? getTruegateHostUrl(path) : path;
    routerPush(target);
});

export const setRenewOnboardingIdFx = createEffect(() => {
    const onboardingContract = FEATURES.getByType<OnboardingModule>(OnboardingModule).getContract();
    onboardingContract.events.clearOnboardingSession();
    onboardingContract.events.setOnboardingDataById("renew");
});

// Samples
sample({
    clock: [renewSubscriptionRequested, subscribeAgainRequested],
    target: [navigateToPaywallFx, setRenewOnboardingIdFx]
}); 